import React from 'react';

const Cart = ({ className }) => {
    return (
        <svg
            className={className}
            width={200}
            height={117}
            viewBox="0 0 200 117"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            //{...props}
        >
            <g clipPath="url(#clip0_2017_264)">
            <rect width={200} height={117} rx={6} fill="#F4F0EC" />
            <path
                d="M120 34C120 32.3431 121.343 31 123 31H149C150.657 31 152 32.3431 152 34V55C152 56.6569 150.657 58 149 58H123C121.343 58 120 56.6569 120 55V34Z"
                fill="#404040"
            />
            <path d="M126.978 39.5H152H126.978Z" fill="#404040" />
            <path
                d="M125 53H138"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M146 53H147"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M131.022 41.5332L128.376 44.519C127.505 45.5023 128.244 47 129.601 47H142.399C143.627 47 144.397 45.7455 143.786 44.7382L140.769 39.7599C140.227 38.8647 138.915 38.7355 138.189 39.5056L136.139 41.6797C135.573 42.2794 134.61 42.3559 133.947 41.8538L133.247 41.3241C132.568 40.8107 131.58 40.9035 131.022 41.5332Z"
                fill="#818181"
            />
            <path
                d="M132 39C133.105 39 134 38.1046 134 37C134 35.8954 133.105 35 132 35C130.895 35 130 35.8954 130 37C130 38.1046 130.895 39 132 39Z"
                fill="#E66819"
            />
            <path
                d="M108 0H194C197.314 0 200 2.68629 200 6V111C200 114.314 197.314 117 194 117H108V0Z"
                fill="#404040"
            />
            <path
                d="M120 15C120 13.3431 121.343 12 123 12H149C150.657 12 152 13.3431 152 15V36C152 37.6569 150.657 39 149 39H123C121.343 39 120 37.6569 120 36V15Z"
                fill="white"
            />
            <path d="M126.978 20.5H152H126.978Z" fill="white" />
            <path
                d="M125 34H138"
                stroke="black"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M146 34H147"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M131.022 22.5332L128.376 25.519C127.505 26.5023 128.244 28 129.601 28H142.399C143.627 28 144.397 26.7455 143.786 25.7382L140.769 20.7599C140.227 19.8647 138.915 19.7355 138.189 20.5056L136.139 22.6797C135.573 23.2794 134.61 23.3559 133.947 22.8538L133.247 22.3241C132.568 21.8107 131.58 21.9035 131.022 22.5332Z"
                fill="#818181"
            />
            <path
                d="M132 20C133.105 20 134 19.1046 134 18C134 16.8954 133.105 16 132 16C130.895 16 130 16.8954 130 18C130 19.1046 130.895 20 132 20Z"
                fill="#E66819"
            />
            <path
                d="M120 48C120 46.3431 121.343 45 123 45H149C150.657 45 152 46.3431 152 48V69C152 70.6569 150.657 72 149 72H123C121.343 72 120 70.6569 120 69V48Z"
                fill="white"
            />
            <path d="M126.978 53.5H152H126.978Z" fill="white" />
            <path
                d="M125 67H138"
                stroke="black"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M146 67H147"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M131.022 55.5332L128.376 58.519C127.505 59.5023 128.244 61 129.601 61H142.399C143.627 61 144.397 59.7455 143.786 58.7382L140.769 53.7599C140.227 52.8647 138.915 52.7355 138.189 53.5056L136.139 55.6797C135.573 56.2794 134.61 56.3559 133.947 55.8538L133.247 55.3241C132.568 54.8107 131.58 54.9035 131.022 55.5332Z"
                fill="#818181"
            />
            <path
                d="M132 53C133.105 53 134 52.1046 134 51C134 49.8954 133.105 49 132 49C130.895 49 130 49.8954 130 51C130 52.1046 130.895 53 132 53Z"
                fill="#E66819"
            />
            <path
                d="M120 81C120 79.3431 121.343 78 123 78H149C150.657 78 152 79.3431 152 81V102C152 103.657 150.657 105 149 105H123C121.343 105 120 103.657 120 102V81Z"
                fill="white"
            />
            <path d="M126.978 86.5H152H126.978Z" fill="white" />
            <path
                d="M125 100H138"
                stroke="black"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M146 100H147"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M131.022 88.5332L128.376 91.519C127.505 92.5023 128.244 94 129.601 94H142.399C143.627 94 144.397 92.7455 143.786 91.7382L140.769 86.7599C140.227 85.8647 138.915 85.7355 138.189 86.5056L136.139 88.6797C135.573 89.2794 134.61 89.3559 133.947 88.8538L133.247 88.3241C132.568 87.8107 131.58 87.9035 131.022 88.5332Z"
                fill="#818181"
            />
            <path
                d="M132 86C133.105 86 134 85.1046 134 84C134 82.8954 133.105 82 132 82C130.895 82 130 82.8954 130 84C130 85.1046 130.895 86 132 86Z"
                fill="#E66819"
            />
            <path
                d="M156 15C156 13.3431 157.343 12 159 12H185C186.657 12 188 13.3431 188 15V36C188 37.6569 186.657 39 185 39H159C157.343 39 156 37.6569 156 36V15Z"
                fill="white"
            />
            <path d="M162.978 20.5H188H162.978Z" fill="white" />
            <path
                d="M161 34H174"
                stroke="black"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M182 34H183"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M167.022 22.5332L164.376 25.519C163.505 26.5023 164.244 28 165.601 28H178.399C179.627 28 180.397 26.7455 179.786 25.7382L176.769 20.7599C176.227 19.8647 174.915 19.7355 174.189 20.5056L172.139 22.6797C171.573 23.2794 170.61 23.3559 169.947 22.8538L169.247 22.3241C168.568 21.8107 167.58 21.9035 167.022 22.5332Z"
                fill="#818181"
            />
            <path
                d="M168 20C169.105 20 170 19.1046 170 18C170 16.8954 169.105 16 168 16C166.895 16 166 16.8954 166 18C166 19.1046 166.895 20 168 20Z"
                fill="#E66819"
            />
            <path
                d="M156 48C156 46.3431 157.343 45 159 45H185C186.657 45 188 46.3431 188 48V69C188 70.6569 186.657 72 185 72H159C157.343 72 156 70.6569 156 69V48Z"
                fill="white"
            />
            <path d="M162.978 53.5H188H162.978Z" fill="white" />
            <path
                d="M161 67H174"
                stroke="black"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M182 67H183"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M167.022 55.5332L164.376 58.519C163.505 59.5023 164.244 61 165.601 61H178.399C179.627 61 180.397 59.7455 179.786 58.7382L176.769 53.7599C176.227 52.8647 174.915 52.7355 174.189 53.5056L172.139 55.6797C171.573 56.2794 170.61 56.3559 169.947 55.8538L169.247 55.3241C168.568 54.8107 167.58 54.9035 167.022 55.5332Z"
                fill="#818181"
            />
            <path
                d="M168 53C169.105 53 170 52.1046 170 51C170 49.8954 169.105 49 168 49C166.895 49 166 49.8954 166 51C166 52.1046 166.895 53 168 53Z"
                fill="#E66819"
            />
            <path
                d="M156 81C156 79.3431 157.343 78 159 78H185C186.657 78 188 79.3431 188 81V102C188 103.657 186.657 105 185 105H159C157.343 105 156 103.657 156 102V81Z"
                fill="white"
            />
            <path d="M162.978 86.5H188H162.978Z" fill="white" />
            <path
                d="M161 100H174"
                stroke="black"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M182 100H183"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M167.022 88.5332L164.376 91.519C163.505 92.5023 164.244 94 165.601 94H178.399C179.627 94 180.397 92.7455 179.786 91.7382L176.769 86.7599C176.227 85.8647 174.915 85.7355 174.189 86.5056L172.139 88.6797C171.573 89.2794 170.61 89.3559 169.947 88.8538L169.247 88.3241C168.568 87.8107 167.58 87.9035 167.022 88.5332Z"
                fill="#818181"
            />
            <path
                d="M168 86C169.105 86 170 85.1046 170 84C170 82.8954 169.105 82 168 82C166.895 82 166 82.8954 166 84C166 85.1046 166.895 86 168 86Z"
                fill="#E66819"
            />
            <g clipPath="url(#clip1_2017_264)">
                <mask
                id="mask0_2017_264"
                style={{
                    maskType: "luminance",
                }}
                maskUnits="userSpaceOnUse"
                x={23}
                y={30}
                width={56}
                height={56}
                >
                <path d="M23 30H79V86H23V30Z" fill="white" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M65.028 49.3843H45.5874C44.7784 49.3843 43.9797 49.5667 43.2509 49.9178C42.522 50.2689 41.8816 50.7798 41.3773 51.4124C40.873 52.045 40.5177 52.7831 40.3379 53.5719C40.158 54.3607 40.1582 55.1799 40.3385 55.9686L42.3049 64.584C42.5767 65.7732 43.2443 66.8349 44.1983 67.5952C45.1522 68.3555 46.3361 68.7693 47.556 68.7689H63.0616C64.2811 68.7688 65.4644 68.3548 66.418 67.5945C67.3715 66.8343 68.0388 65.7728 68.3105 64.584L70.2769 55.9686C70.4572 55.1799 70.4574 54.3607 70.2776 53.5719C70.0977 52.7831 69.7424 52.045 69.2381 51.4124C68.7338 50.7798 68.0934 50.2689 67.3645 49.9178C66.6357 49.5667 65.837 49.3843 65.028 49.3843ZM45.3483 53.72C45.4267 53.7017 45.5069 53.6923 45.5874 53.692H65.028C65.1897 53.6921 65.3492 53.7287 65.4948 53.7989C65.6404 53.8692 65.7683 53.9713 65.869 54.0977C65.9698 54.2241 66.0408 54.3715 66.0768 54.5291C66.1128 54.6867 66.1128 54.8504 66.0769 55.008L64.1105 63.6234C64.0563 63.8611 63.9231 64.0735 63.7325 64.2257C63.542 64.3779 63.3054 64.4609 63.0616 64.4612H47.5539C47.31 64.4609 47.0734 64.3779 46.8829 64.2257C46.6923 64.0735 46.5591 63.8611 46.5049 63.6234L44.5385 55.008C44.4754 54.7298 44.5252 54.438 44.677 54.1965C44.8289 53.955 45.0703 53.7836 45.3483 53.72Z"
                    fill="black"
                />
                <path
                    d="M36.9786 40.7691H33.7693C33.1981 40.7691 32.6503 40.5422 32.2463 40.1383C31.8424 39.7343 31.6155 39.1865 31.6155 38.6153C31.6155 38.044 31.8424 37.4962 32.2463 37.0923C32.6503 36.6883 33.1981 36.4614 33.7693 36.4614H38.7016C39.1903 36.4617 39.6644 36.6281 40.0461 36.9334C40.4277 37.2387 40.6941 37.6647 40.8016 38.1414L46.6386 63.9876C46.7108 64.2669 46.7262 64.5579 46.6839 64.8433C46.6415 65.1286 46.5422 65.4026 46.392 65.6489C46.2417 65.8952 46.0435 66.1087 45.8091 66.2769C45.5747 66.4452 45.3089 66.5646 45.0274 66.6281C44.746 66.6916 44.4547 66.6979 44.1708 66.6466C43.8868 66.5954 43.6161 66.4876 43.3746 66.3297C43.1332 66.1718 42.9259 65.967 42.7651 65.7275C42.6043 65.488 42.4932 65.2185 42.4386 64.9353L36.9786 40.7691ZM51.0001 73.6153C51.0001 74.6149 50.603 75.5737 49.8961 76.2805C49.1892 76.9874 48.2305 77.3845 47.2309 77.3845C46.2312 77.3845 45.2725 76.9874 44.5656 76.2805C43.8587 75.5737 43.4616 74.6149 43.4616 73.6153C43.4616 72.6156 43.8587 71.6569 44.5656 70.95C45.2725 70.2432 46.2312 69.846 47.2309 69.846C48.2305 69.846 49.1892 70.2432 49.8961 70.95C50.603 71.6569 51.0001 72.6156 51.0001 73.6153ZM66.077 73.6153C66.077 74.1103 65.9795 74.6004 65.7901 75.0577C65.6007 75.515 65.323 75.9305 64.973 76.2805C64.623 76.6305 64.2075 76.9082 63.7502 77.0976C63.2929 77.287 62.8028 77.3845 62.3078 77.3845C61.8128 77.3845 61.3227 77.287 60.8654 77.0976C60.4081 76.9082 59.9925 76.6305 59.6425 76.2805C59.2925 75.9305 59.0149 75.515 58.8255 75.0577C58.6361 74.6004 58.5386 74.1103 58.5386 73.6153C58.5386 72.6156 58.9357 71.6569 59.6425 70.95C60.3494 70.2432 61.3081 69.846 62.3078 69.846C63.3074 69.846 64.2662 70.2432 64.973 70.95C65.6799 71.6569 66.077 72.6156 66.077 73.6153Z"
                    fill="black"
                />
                </mask>
                <g mask="url(#mask0_2017_264)">
                <path
                    d="M51 86C66.464 86 79 73.464 79 58C79 42.536 66.464 30 51 30C35.536 30 23 42.536 23 58C23 73.464 35.536 86 51 86Z"
                    fill="#E66819"
                />
                </g>
            </g>
            </g>
            <defs>
            <clipPath id="clip0_2017_264">
                <rect width={200} height={117} fill="white" />
            </clipPath>
            <clipPath id="clip1_2017_264">
                <rect
                width={56}
                height={56}
                fill="white"
                transform="translate(23 30)"
                />
            </clipPath>
            </defs>
        </svg>
    )
}

export default Cart;